'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _play = require('./play.view');

var _play2 = _interopRequireDefault(_play);

var _video = require('../../../constants/events/video');

var _video2 = _interopRequireDefault(_video);

var _ui = require('../../../constants/events/ui');

var _ui2 = _interopRequireDefault(_ui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PlayControl = function () {
  function PlayControl(_ref) {
    var engine = _ref.engine,
        eventEmitter = _ref.eventEmitter;

    _classCallCheck(this, PlayControl);

    this._engine = engine;
    this._eventEmitter = eventEmitter;

    this._isPlaying = null;

    this._bindCallbacks();
    this._initUI();
    this._bindEvents();

    this.setControlStatus(false);
  }

  _createClass(PlayControl, [{
    key: '_bindCallbacks',
    value: function _bindCallbacks() {
      this._togglePlayback = this._togglePlayback.bind(this);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_video2.default.STATE_CHANGED, this._updatePlayingStatus, this);
    }
  }, {
    key: '_togglePlayback',
    value: function _togglePlayback() {
      if (this._isPlaying) {
        this._pauseVideo();
      } else {
        this._playVideo();
      }
    }
  }, {
    key: '_playVideo',
    value: function _playVideo() {
      this._engine.play();

      this._eventEmitter.emit(_ui2.default.PLAY_TRIGGERED);
    }
  }, {
    key: '_pauseVideo',
    value: function _pauseVideo() {
      this._engine.pause();

      this._eventEmitter.emit(_ui2.default.PAUSE_TRIGGERED);
    }
  }, {
    key: '_updatePlayingStatus',
    value: function _updatePlayingStatus(_ref2) {
      var nextState = _ref2.nextState;

      if (nextState === this._engine.STATES.SRC_SET) {
        this.reset();
      } else if (nextState === this._engine.STATES.PLAY_REQUESTED) {
        this.setControlStatus(true);
      } else if (nextState === this._engine.STATES.PAUSED || nextState === this._engine.STATES.ENDED) {
        this.setControlStatus(false);
      }
    }
  }, {
    key: '_initUI',
    value: function _initUI() {
      var config = {
        callbacks: {
          onTogglePlaybackButtonClick: this._togglePlayback
        }
      };

      this.view = new this.constructor.View(config);
    }
  }, {
    key: 'setControlStatus',
    value: function setControlStatus(isPlaying) {
      this._isPlaying = isPlaying;
      this.view.setState({ isPlaying: this._isPlaying });
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_video2.default.STATE_CHANGED, this._updatePlayingStatus, this);
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.setControlStatus(false);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();
      this.view.destroy();
      delete this.view;

      delete this._eventEmitter;
      delete this._engine;
    }
  }, {
    key: 'node',
    get: function get() {
      return this.view.getNode();
    }
  }]);

  return PlayControl;
}();

PlayControl.View = _play2.default;
exports.default = PlayControl;
//# sourceMappingURL=play.controler.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/ui/controls/play/play.controler.js
// module id = 1227
// module chunks = 1 2 3